export const REPLAY_CONTROL_BITS = {
    throttleForward: 1 << 0,
    throttleReverse: 1 << 1,
    brake: 1 << 2,
    steerLeft: 1 << 3,
    steerRight: 1 << 4,
};
export const KNOWN_REPLAY_CONTROL_BITS = REPLAY_CONTROL_BITS.throttleForward |
    REPLAY_CONTROL_BITS.throttleReverse |
    REPLAY_CONTROL_BITS.brake |
    REPLAY_CONTROL_BITS.steerLeft |
    REPLAY_CONTROL_BITS.steerRight;
export function encodeReplayControls(controls) {
    let bits = 0;
    if (controls.throttle === 1)
        bits |= REPLAY_CONTROL_BITS.throttleForward;
    if (controls.throttle === -1)
        bits |= REPLAY_CONTROL_BITS.throttleReverse;
    if (controls.brake === 1)
        bits |= REPLAY_CONTROL_BITS.brake;
    if (controls.steering === -1)
        bits |= REPLAY_CONTROL_BITS.steerLeft;
    if (controls.steering === 1)
        bits |= REPLAY_CONTROL_BITS.steerRight;
    return bits;
}
export function decodeReplayControls(bits) {
    validateReplayControlBits(bits);
    return {
        throttle: bits & REPLAY_CONTROL_BITS.throttleForward
            ? 1
            : bits & REPLAY_CONTROL_BITS.throttleReverse
                ? -1
                : 0,
        brake: bits & REPLAY_CONTROL_BITS.brake ? 1 : 0,
        steering: bits & REPLAY_CONTROL_BITS.steerLeft
            ? -1
            : bits & REPLAY_CONTROL_BITS.steerRight
                ? 1
                : 0,
    };
}
export function validateReplayControlBits(bits) {
    if (!Number.isInteger(bits) || bits < 0 || bits > KNOWN_REPLAY_CONTROL_BITS) {
        throw new Error("Replay controls contain unknown bits");
    }
    if (bits & REPLAY_CONTROL_BITS.throttleForward &&
        bits & REPLAY_CONTROL_BITS.throttleReverse) {
        throw new Error("Replay controls contain both throttle directions");
    }
    if (bits & REPLAY_CONTROL_BITS.steerLeft &&
        bits & REPLAY_CONTROL_BITS.steerRight) {
        throw new Error("Replay controls contain both steering directions");
    }
}
